export default "__VITE_ASSET__7C$$b_l8__"